import React, { useEffect, useState } from "react";
import WhatsAppWidget from "react-whatsapp-chat-widget";
import "../main.css";
import "../Components/stylewa.css";

export default function Footer() {
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);

  useEffect(() => {
    const openWidget = () => setIsWidgetOpen(true);

    // Adiciona o event listener para abrir o widget
    window.addEventListener("openWhatsAppWidget", openWidget);

    return () => {
      // Remove o event listener quando o componente for desmontado
      window.removeEventListener("openWhatsAppWidget", openWidget);
    };
  }, []);

  return (
    <footer className="footer">
      <div className="container-footer col-md-11">
        <div className="text-left col-md-5">
          <div>
            <img src="img/logo-salesbox-footer.png" alt="logo" />
          </div>
          <div className="copyright">
            &copy;{" "}
            <a
              href="https://site.salesbox.com.br/"
              target="blank"
              className="text-white"
            >
              Sales Box
            </a>
            , All Right Reserved 2024.
          </div>
        </div>
        <div className="col-md-7 container-footer-filho" data-wow-delay="0.5s">
          <a
            className="btn btn-link"
            href="https://site.salesbox.com.br/"
            target="blank"
          >
            Site
          </a>
          <a
            className="btn btn-link"
            href="https://site.salesbox.com.br/privacidade"
            target="blank"
          >
            Política de privacidade
          </a>
          <a
            className="btn btn-link"
            href="https://site.salesbox.com.br/termodeuso"
            target="blank"
          >
            Termos de uso
          </a>
        </div>
      </div>

      <div className="whatsapp-widget-container">
        <WhatsAppWidget
          phoneNo="+5511951525615"
          widgetWidth="300px"
          widgetWidthMobile="260px"
          autoOpen={isWidgetOpen}
          //messageBox={true}
          messageBoxTxt=""
          iconColor="white"
          iconBgColor="#25D366"
          headerIcon="/img/logo-whats.png"
          headerTitle="Sales Box"
          headerCaption="Online"
          bodyBgColor="#f1f1f1"
          chatPersonName="Atendimento"
          chatMessage={
            <>
              Olá 👋 <br />
              <br /> Por favor, clique no botão abaixo e nossa equipe de suporte
              estará pronta para te ajudar.
            </>
          }
          headerBgColor="#6c48b0"
          footerBgColor="#e6e6e6"
          placeholder="Escreva sua mensagem.."
          btnBgColor="#6c48b0"
          btnTxt="Iniciar Conversa"
          btnTxtColor="white"
        />
      </div>
    </footer>
  );
}
